module.exports = __webpack_public_path__ + "img/1.9billion.56ed47fe.svg";